(() => {
  const normalize = value => String(value || '').toLocaleLowerCase('sv').normalize('NFD').replace(/[\u0300-\u036f]/g, '');
  const sizeOf = weight => weight <= 0 ? 'unknown' : weight < 500 ? 'small' : weight < 1000 ? 'medium' : weight < 2000 ? 'large' : weight < 5000 ? 'extra_large' : 'box_size';
  const cookingGroups = {
    stew: new Set('hostbox hogrev hogrevshjarta bogstek grytbitkott-not ytterlar notlagg notrulle oxbringa kokbox hushallsbox-not notbox notbox-reso detaljbox detaljbox-reso farbog farlagg grytbitkott_far lammbog lammbog-skivad-med-ben grytbitar_lamm lammlagg lammbox lammbox-finstyckat rimmat-flasklagg picnicbog grisbox kycklingben kycklinglarfile strimlat_notkott strimlat-flaskkott'.split(' ')),
    slow: new Set('hostbox hogrev bogstek brisket brisket-stor oxbringa notlagg shortribs farbog farlagg farstek lammbog lammlagg picnicbog kamben spare-ribs rimmat-flasklagg grisbox kokbox'.split(' '))
  };
  class SeasonCatalog extends HTMLElement {
    static classify(data) {
      const tags = data.tags.map(normalize), title = normalize(data.title), handle = data.handle;
      const has = value => tags.includes(value);
      const bone = /buljong|margben|tonkotsu/.test(title), bottle = bone && !/box|ben$/.test(title);
      const box = has('boxar'), mince = /fars/.test(title);
      const species = [];
      if (has('not') || has('notkott')) species.push('beef');
      if (has('farkott') || /^far/.test(title)) species.push('mutton');
      else if (has('lammkott') || has('lamm/far') || /lamm/.test(title)) species.push('lamb');
      if (has('gris') || has('griskott')) species.push('pork');
      if (has('kyckling')) species.push('chicken');
      const kind = [];
      if (box) kind.push('boxes');
      if (bone) kind.push('bones');
      if (mince) kind.push('mince');
      if (!box && !bone && !mince) kind.push('cuts');
      const cooking = [];
      if (cookingGroups.stew.has(handle)) cooking.push('stew');
      if (has('ugnsbaka') || ['hostbox','oxbringa','farbog'].includes(handle)) cooking.push('oven');
      if (cookingGroups.slow.has(handle)) cooking.push('slow');
      if (mince) cooking.push('mince_meal');
      if (bone) cooking.push('broth_meal');
      const storage = [];
      if (has('djupfryst')) storage.push('frozen');
      if (has('farskvaror') || has('farskvara')) storage.push('fresh');
      return {species, kind, cooking, storage, bottle};
    }
    connectedCallback() {
      this.controller?.abort(); this.controller = new AbortController();
      const signal = this.controller.signal;
      const entities = {'&amp;':'&','&lt;':'<','&gt;':'>','&quot;':'"','&#39;':"'"};
      this.labels = Object.fromEntries(Object.entries(JSON.parse(this.querySelector('[data-filter-labels]').textContent)).map(([key,value]) => [key,value.replace(/&(?:amp|lt|gt|quot|#39);/g,entity => entities[entity])]));
      this.readRecords();
      this.grid = this.querySelector('.gs-products');
      this.expand = this.querySelector('[data-expand-products]');
      this.counter = this.querySelector('[data-product-count]');
      this.empty = this.querySelector('[data-catalog-empty]');
      this.sort = this.querySelector('[data-catalog-sort]');
      this.status = this.querySelector('[data-catalog-status]');
      this.retry = this.querySelector('[data-catalog-retry]');
      this.pagination = this.querySelector('[data-catalog-pagination]');
      this.loading = !!this.dataset.nextPage || Number(this.dataset.currentPage) > 1;
      this.loadFailed = false;
      this.initial = Number(this.dataset.initialCount) || 4;
      this.visibleLimit = this.initial;
      this.state = {groups:{}, query:'', min:null, max:null, sort:'recommended'};
      this.inputs = [];
      this.querySelectorAll('[data-catalog-tools]').forEach(el => el.hidden = this.loading);
      if(this.pagination)this.pagination.hidden = true;
      this.retry?.addEventListener('click', () => this.loadAllPages(signal), {signal});
      this.sort.addEventListener('change', () => { this.state.sort = this.sort.value; this.visibleLimit = this.initial; this.paint(); }, {signal});
      this.expand.addEventListener('click', () => {
        const oldLimit = this.visibleLimit;
        this.visibleLimit += 24; this.paint();
        this.matches[oldLimit]?.el.querySelector('a')?.focus({preventScroll:true});
      }, {signal});
      if (this.dataset.filtersEnabled === 'true') {
        this.sidebar = this.querySelector('.gs-filter-sidebar');
        this.active = this.querySelector('[data-active-filters]');
        this.search = this.querySelector('[data-catalog-search]');
        this.minimum = this.querySelector('[data-price-min]');
        this.maximum = this.querySelector('[data-price-max]');
        this.maximum.placeholder = String(Math.ceil(Math.max(0,...this.records.flatMap(r => r.variants.map(v => v.price)))/100));
        if(!this.loading)this.buildGroups();
        this.sidebar.hidden = this.loading;
        this.sidebar.addEventListener('input', event => {
          if(event.target.matches('[data-facet]')) this.readGroups();
          this.state.query = this.search.value;
          this.state.min = this.minimum.value === '' ? null : Math.max(0, Number(this.minimum.value)*100);
          this.state.max = this.maximum.value === '' ? null : Math.max(0, Number(this.maximum.value)*100);
          this.visibleLimit = this.initial; this.paint();
        }, {signal});
        this.querySelector('[data-clear-filters]').addEventListener('click', () => this.clear(), {signal});
        this.active.addEventListener('click', event => {
          const button = event.target.closest('button[data-remove-filter]'); if(!button)return;
          const {group,value} = button.dataset;
          if(group === 'query')this.search.value = '';
          else if(group === 'price'){this.minimum.value = '';this.maximum.value = '';}
          else this.inputs.filter(input => input.dataset.facet === group && input.value === value).forEach(input => input.checked = false);
          this.readGroups(); this.state.query = this.search.value;
          this.state.min = this.minimum.value === '' ? null : Number(this.minimum.value)*100;
          this.state.max = this.maximum.value === '' ? null : Number(this.maximum.value)*100;
          this.visibleLimit = this.initial; this.paint();
          (this.active.querySelector('button') || this.search).focus({preventScroll:true});
        }, {signal});
      }
      this.dataset.ready = 'true'; this.paint();
      if(this.loading)this.loadAllPages(signal);
    }
    readRecords() {
      this.records = [...this.querySelectorAll('[data-catalog-item]')].map((el,index) => {
        const data = {el,index,title:el.dataset.title,handle:el.dataset.handle,tags:JSON.parse(el.dataset.tags),variants:JSON.parse(el.dataset.variants),price:Number(el.dataset.price)};
        data.facets = SeasonCatalog.classify(data);
        data.search = normalize([data.title,...data.tags].join(' '));
        return data;
      });
    }
    async loadAllPages(signal) {
      this.loading = true;this.loadFailed = false;this.retry.hidden = true;
      if(this.pagination)this.pagination.hidden = true;
      this.paint();
      const onFirstPage = Number(this.dataset.currentPage || 1) === 1;
      const cards = onFirstPage ? this.records.map(record => record.el) : [];
      const first = new URL(window.location.href);first.searchParams.set(this.dataset.pageParam || 'page','1');
      let next = onFirstPage ? this.dataset.nextPage : first.href;
      const visited = new Set();
      try {
        while(next) {
          const url = new URL(next,window.location.href);
          if(url.origin !== window.location.origin)throw new Error('Invalid collection origin');
          const current = new URL(window.location.href);
          for(const key of ['view','preview_theme_id'])if(current.searchParams.has(key))url.searchParams.set(key,current.searchParams.get(key));
          url.searchParams.delete('sections');url.searchParams.set('section_id',this.dataset.sectionId);
          if(visited.has(url.href))throw new Error('Repeated collection page');
          visited.add(url.href);
          const request = new AbortController();
          const abort = () => request.abort();signal.addEventListener('abort',abort,{once:true});
          const timer = setTimeout(abort,20000);
          let html;
          try {
            const response = await fetch(url,{signal:request.signal,credentials:'same-origin'});
            if(!response.ok)throw new Error('Collection page failed');
            html = await response.text();
          } finally {clearTimeout(timer);signal.removeEventListener('abort',abort);}
          if(signal.aborted || !this.isConnected)return;
          const doc = new DOMParser().parseFromString(html,'text/html');
          const page = [...doc.querySelectorAll('gg-season-catalog')].find(el=>el.dataset.sectionId === this.dataset.sectionId && el.dataset.collectionId === this.dataset.collectionId);
          if(!page || Number(page.dataset.currentPage) !== Number(url.searchParams.get(this.dataset.pageParam || 'page')))throw new Error('Invalid collection page');
          for(const card of page.querySelectorAll('[data-catalog-item]')) {
            card.querySelectorAll('script').forEach(script=>script.remove());card.hidden = true;cards.push(card);
          }
          next = page.dataset.nextPage;
        }
        if(signal.aborted || !this.isConnected)return;
        const ids = new Set();
        this.grid.replaceChildren(...cards.filter(card=>{
          const id = card.dataset.productId;if(ids.has(id))return false;ids.add(id);return true;
        }));
        this.readRecords();this.loading = false;this.dataset.nextPage = '';this.dataset.currentPage = '1';
        if(this.sidebar) {
          this.inputs = [];this.buildGroups();this.sidebar.hidden = false;
          this.maximum.placeholder = String(Math.ceil(Math.max(0,...this.records.flatMap(r=>r.variants.map(v=>v.price)))/100));
        }
        this.querySelectorAll('[data-catalog-tools]').forEach(el=>el.hidden = false);
        this.paint();
      } catch(error) {
        if(signal.aborted || !this.isConnected)return;
        this.loading = false;this.loadFailed = true;this.retry.hidden = false;
        if(this.pagination)this.pagination.hidden = false;
        this.paint();
      }
    }
    format(key, values = {}) {return Object.entries(values).reduce((s,[name,value]) => s.replaceAll('{'+name+'}',String(value)),this.labels[key] || key);}
    node(tag, className, text) {const el = document.createElement(tag); if(className)el.className = className; if(text != null)el.textContent = text; return el;}
    buildGroups() {
      this.groups = {
        cooking:['stew','oven','slow','mince_meal','broth_meal'],
        species:['beef','lamb','mutton','chicken','pork'],
        kind:['boxes','cuts','mince','bones'],
        size:['small','medium','large','extra_large','box_size','bottles'],
        storage:['fresh','frozen'], availability:['orderable']
      };
      const root = this.querySelector('[data-filter-groups]'); root.replaceChildren();
      Object.entries(this.groups).forEach(([group,values]) => {
        const details = this.node('details','gs-filter-group'); details.open = group === 'cooking';
        const summary = this.node('summary','',this.labels[group]);
        const icon = this.node('span','ggicon','K'); icon.setAttribute('aria-hidden','true'); summary.append(icon); details.append(summary);
        const options = this.node('div','gs-filter-options');
        values.forEach(value => {
          if(!this.records.some(record => this.matchGroup(record,group,[value])))return;
          const label = this.node('label','gs-filter-option'), input = this.node('input');
          input.type = 'checkbox';input.value = value;input.dataset.facet = group;
          const text = this.node('span','gs-filter-option-label',this.labels[value]);
          const count = this.node('span','gs-filter-option-count'); count.setAttribute('aria-hidden','true');
          label.append(input,text,count);options.append(label); this.inputs.push(input);
        });
        if(options.children.length){details.append(options);root.append(details);}
      });
    }
    readGroups() {
      this.state.groups = {};
      this.inputs.filter(input => input.checked).forEach(input => (this.state.groups[input.dataset.facet] ||= []).push(input.value));
    }
    variantMatches(record, variant, groups = this.state.groups) {
      const sizes = groups.size || [];
      if(sizes.length && !sizes.includes(record.facets.bottle ? 'bottles' : sizeOf(variant.weight)))return false;
      if(groups.availability?.length && !variant.available)return false;
      return (this.state.min == null || variant.price >= this.state.min) && (this.state.max == null || variant.price <= this.state.max);
    }
    matchGroup(record, group, selected) {
      if(!selected.length)return true;
      if(group === 'size')return record.variants.some(v => selected.includes(record.facets.bottle ? 'bottles' : sizeOf(v.weight)));
      if(group === 'availability')return record.variants.some(v => v.available);
      return selected.some(value => record.facets[group]?.includes(value));
    }
    matchesRecord(record, omitGroup, overrideValue) {
      const words = normalize(this.state.query).trim().split(/\s+/).filter(Boolean);
      if(!words.every(word => record.search.includes(word)))return false;
      const groups = {...this.state.groups};
      if(omitGroup)groups[omitGroup] = overrideValue ? [overrideValue] : [];
      for(const [group,selected] of Object.entries(groups)) {
        if(group !== 'size' && group !== 'availability' && !this.matchGroup(record,group,selected))return false;
      }
      return record.variants.some(variant => this.variantMatches(record,variant,groups));
    }
    matchedPrice(record) {return Math.min(...record.variants.filter(v => this.variantMatches(record,v)).map(v => v.price));}
    clear() {
      this.inputs.forEach(input => input.checked = false);
      this.search.value = '';this.minimum.value = '';this.maximum.value = '';
      this.state.groups = {};this.state.query = '';this.state.min = null;this.state.max = null;this.visibleLimit = this.initial;this.paint();
    }
    paint() {
      const active = !!this.state.query.trim() || Object.values(this.state.groups).some(values => values.length) || this.state.min != null || this.state.max != null;
      this.matches = this.records.filter(record => this.matchesRecord(record));
      const sort = this.state.sort;
      this.matches.sort((a,b) => sort === 'price_low' ? this.matchedPrice(a)-this.matchedPrice(b) : sort === 'price_high' ? this.matchedPrice(b)-this.matchedPrice(a) : sort === 'name' ? a.title.localeCompare(b.title,'sv') : a.index-b.index);
      const count = this.matches.length, total = this.records.length;
      if(this.counter)this.counter.textContent = this.format(this.loading ? 'loading' : this.loadFailed ? 'partial_count' : active ? 'filtered_count':'all_count',{count,total});
      if(this.status){this.status.hidden = !this.loading && !this.loadFailed;this.status.textContent = this.loading ? this.format('loading') : this.loadFailed ? this.format('load_failed') : '';}
      const visible = new Set(this.matches.slice(0,this.visibleLimit));
      this.records.forEach(record => record.el.hidden = !visible.has(record));
      this.matches.forEach(record => this.grid.append(record.el));
      cancelAnimationFrame(this.galleryFrame);
      this.galleryFrame = requestAnimationFrame(() => {
        visible.forEach(record => {
          const gallery = record.el.querySelector('[data-wld-card-gallery]');
          const track = gallery?.querySelector('[data-wld-card-gallery-track]');
          if(!track || !track.clientWidth)return;
          const prev = gallery.querySelector('[data-wld-card-gallery-prev]');
          const next = gallery.querySelector('[data-wld-card-gallery-next]');
          if(prev)prev.disabled = track.scrollLeft <= 2;
          if(next)next.disabled = track.scrollLeft >= Math.max(0,track.scrollWidth-track.clientWidth)-2;
        });
      });
      this.expand.hidden = count <= this.visibleLimit;
      this.empty.hidden = count !== 0;
      this.inputs.forEach(input => {
        const count = this.records.filter(record => this.matchesRecord(record,input.dataset.facet,input.value)).length;
        input.disabled = count === 0 && !input.checked;
        input.parentElement.querySelector('.gs-filter-option-count').textContent = '('+count+')';
      });
      if(this.active)this.paintActive();
    }
    paintActive() {
      this.active.replaceChildren();
      const add = (group,value,text) => {
        const button = this.node('button','gs-filter-chip');button.type = 'button';button.dataset.removeFilter = '';button.dataset.group = group;button.dataset.value = value;
        button.setAttribute('aria-label',this.format('remove',{label:text}));button.append(this.node('span','',text));
        const icon = this.node('span','ggicon','O');icon.setAttribute('aria-hidden','true');button.append(icon);this.active.append(button);
      };
      Object.entries(this.state.groups).forEach(([group,values]) => values.forEach(value => add(group,value,this.labels[value])));
      if(this.state.query.trim())add('query','',this.state.query.trim());
      if(this.state.min != null || this.state.max != null)add('price','',(this.state.min == null ? '0':this.state.min/100)+'–'+(this.state.max == null ? '∞':this.state.max/100)+' kr');
      this.active.hidden = !this.active.children.length;
    }
    disconnectedCallback() {this.controller?.abort();cancelAnimationFrame(this.galleryFrame);}
  }
  if(!customElements.get('gg-season-catalog'))customElements.define('gg-season-catalog',SeasonCatalog);
})();
